import React from 'react';

interface CheckBoxIconProps {
  className?: string;
  width?: number;
  height?: number;
}

const CheckBoxIconIcon = function CheckBoxIconIcon({
  className,
  width,
  height,
}: CheckBoxIconProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
      </svg>
    </svg>
  );
};

CheckBoxIconIcon.defaultProps = {
  className: '',
  width: 24,
  height: 24,
};

export default CheckBoxIconIcon;
